import React from 'react';
export function Benefits() {
  return <section className="my-12 py-8 border-t border-b border-[#E5E5E0]" data-id="element-38">
      <h2 className="text-[24px] font-bold text-[#1a1a1a] mb-6 font-serif" data-id="element-39">
        What Makes This Approach Different
      </h2>

      <div className="space-y-6" data-id="element-40">
        <div className="flex gap-4 items-start" data-id="element-41">
          <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#8B2500]/10 text-[#8B2500] flex items-center justify-center text-xs mt-1" data-id="element-42">
            ✓
          </span>
          <div data-id="element-43">
            <h3 className="text-[16px] font-bold text-[#1a1a1a] mb-1 font-sans" data-id="element-44">
              Stop Guessing
            </h3>
            <p className="text-[16px] text-[#4a4a4a] leading-relaxed" data-id="element-45">
              Most people try random exercises from YouTube. This method gives
              you real control over your knee with a structured plan.
            </p>
          </div>
        </div>

        <div className="flex gap-4 items-start" data-id="element-46">
          <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#8B2500]/10 text-[#8B2500] flex items-center justify-center text-xs mt-1" data-id="element-47">
            ✓
          </span>
          <div data-id="element-48">
            <h3 className="text-[16px] font-bold text-[#1a1a1a] mb-1 font-sans" data-id="element-49">
              No Gym Required
            </h3>
            <p className="text-[16px] text-[#4a4a4a] leading-relaxed" data-id="element-50">
              A premium digital guide built for real people. No impact, no gym
              membership, and absolutely no "push through the pain" culture.
            </p>
          </div>
        </div>

        <div className="flex gap-4 items-start" data-id="element-51">
          <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#8B2500]/10 text-[#8B2500] flex items-center justify-center text-xs mt-1" data-id="element-52">
            ✓
          </span>
          <div data-id="element-53">
            <h3 className="text-[16px] font-bold text-[#1a1a1a] mb-1 font-sans" data-id="element-54">
              Progressive 3-Step System
            </h3>
            <p className="text-[16px] text-[#4a4a4a] leading-relaxed" data-id="element-55">
              It follows a logical sequence: Reset the Angles, Lock in
              Stability, then Train the Walk.
            </p>
          </div>
        </div>

        <div className="flex gap-4 items-start" data-id="element-56">
          <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#8B2500]/10 text-[#8B2500] flex items-center justify-center text-xs mt-1" data-id="element-57">
            ✓
          </span>
          <div data-id="element-58">
            <h3 className="text-[16px] font-bold text-[#1a1a1a] mb-1 font-sans" data-id="element-59">
              Pain Traffic Light System
            </h3>
            <p className="text-[16px] text-[#4a4a4a] leading-relaxed" data-id="element-60">
              Includes a Green/Yellow/Red system that tells you exactly what to
              adjust when something flares up, so you never lose progress.
            </p>
          </div>
        </div>
      </div>
    </section>;
}